module.exports = __webpack_public_path__ + "images/hero_mission1_9f71cda3aec7418c5964e01c40840e25.jpg";